import { Injectable } from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {User} from '../interfaces/user';
import {Serializer} from '../interfaces/serializer';

@Injectable({
  providedIn: 'root'
})
export class DecimalService {

  constructor() { }

  public format(user: Serializer<User> | undefined | null, value: number, digitsInfo: string = '1.2-2'): string {
    return new DecimalPipe(user?.attributes?.number_format || 'fr-FR').transform(value, digitsInfo);
  }

}
